// extracted by mini-css-extract-plugin
export default {"wrapper":"Error_wrapper__s6Hxa","center":"Error_center__HiAo5","status":"Error_status__KE99a","message":"Error_message__6g8eK"};